import * as yup from 'yup';

export const validationSchema = yup.object().shape({
    Email: yup.string().email('Неверный формат email').required('Обязательное поле'),
});
